// Library Methods
import { useCallback } from "react";

type HTMLStyleType = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>;

const axes = ["YNeg", "YPos", "XNeg", "XPos"];

const GPACross = ({
  height = 312,
  width = 312,
  borderWidth = 2,
  tickSize = 6,
  tickNum = 3,
}) => {
  const widthPx = `${width}px`;
  const heightPx = `${height}px`;

  const halfWidthPx = `${(width - borderWidth) / 2}px`;
  const halfHeightPx = `${(height - borderWidth) / 2}px`;

  const tickSizePx = `${tickSize}px`;
  const borderWidthPx = `${borderWidth}px`;

  const getChartTicks = useCallback(
    (axis: string) => {
      return [...Array(tickNum)].map((_, index) => {
        const styles = {
          YNeg: {
            position: "absolute",
            width: tickSizePx,
            left: halfWidthPx,
            transform: "translateX(-50%)",

            top: `calc(
              ${halfHeightPx} + ${halfHeightPx} / ${tickNum} * ${index + 1}
            )`,
          } as HTMLStyleType,
          YPos: {
            position: "absolute",
            width: tickSizePx,
            left: halfWidthPx,
            transform: "translateX(-50%)",

            top: `calc(
              ${halfHeightPx} - ${halfHeightPx} / ${tickNum} * ${index + 1}
            )`,
          } as HTMLStyleType,
          XNeg: {
            position: "absolute",
            height: tickSizePx,
            top: halfHeightPx,
            transform: "translateY(-50%)",

            left: `calc(
              ${halfWidthPx} - ${halfWidthPx} / ${tickNum} * ${index + 1}
            )`,
          } as HTMLStyleType,
          XPos: {
            position: "absolute",
            height: tickSizePx,
            top: halfHeightPx,
            transform: "translateY(-50%)",

            left: `calc(
              ${halfWidthPx} + ${halfWidthPx} / ${tickNum} * ${index + 1}
            )`,
          } as HTMLStyleType,
        };

        return (
          <div
            key={`${axis}${index + 1}`}
            style={{ ...styles[axis as keyof typeof styles] }}
          />
        );
      });
    },
    [halfWidthPx, halfHeightPx, tickNum, tickSizePx]
  );

  return (
    <div>
      {/* Y axis line */}
      <div
        style={{
          position: "absolute",
          borderRight: `${borderWidthPx} solid #000`,
          height: heightPx,
          marginLeft: halfWidthPx,
        }}
      />

      {/* X axis line */}
      <div
        style={{
          position: "absolute",
          borderBottom: `${borderWidthPx} solid #000`,
          width: widthPx,
          marginTop: halfHeightPx,
        }}
      />

      {/* Tick marks on X and Y axes */}
      {axes.map((axis) => getChartTicks(axis))}
    </div>
  );
};

export default GPACross;
